export const getShortUrl = (data, maxLength = 80) => {
  if (data.length < maxLength) {
    return data;
  } else {
    let urlParts = data.split('/');
    let shortenedUrlParts = urlParts.slice(2);
    let shortenedUrl = shortenedUrlParts[0] + '/.../';
    if (shortenedUrlParts[shortenedUrlParts.length - 1] === '') {
      return (
        'https://' +
        shortenedUrl +
        shortenedUrlParts[shortenedUrlParts.length - 2]
      );
    } else
      return (
        'https://' +
        shortenedUrl +
        shortenedUrlParts[shortenedUrlParts.length - 1]
      );
  }
};
